import { render, staticRenderFns } from "./LocationLaborReport.vue?vue&type=template&id=080458ea&scoped=true&"
import script from "./LocationLaborReport.vue?vue&type=script&lang=js&"
export * from "./LocationLaborReport.vue?vue&type=script&lang=js&"
import style0 from "./LocationLaborReport.vue?vue&type=style&index=0&id=080458ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080458ea",
  null
  
)

export default component.exports